import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLanguages } from "@insite/client-framework/Store/Context/ContextSelectors";
import setLanguage from "@insite/client-framework/Store/Context/Handlers/SetLanguage";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import DynamicDropdown, { DynamicDropdownProps } from "@insite/mobius/DynamicDropdown";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Circle from "@tIntermatic/Icons/Circle";
import Region from "@tIntermatic/Icons/Region";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    itemName = "itemName",
    showIcon = "showIcon",
    languageMenu = "languageMenu",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.itemName]: any;
        [fields.showIcon]: boolean;
        [fields.languageMenu]: boolean;
    };
}

export interface DropDownMenuStyles {
    regionIcon?: IconPresentationProps;
    dropdownSelect?: DynamicDropdownProps;
    menuWrapper?: InjectableCss;
    iconElementEnabled?: IconPresentationProps;
    iconElementDisabled?: IconPresentationProps;
}

export const dropdownStyles = {
    menuWrapper: {
        css: css`
            display: flex;
            font-size: 14px;
            height: auto;
            font-weight: 300;
            div[aria-owns="language-dropdown"] {
                span[class^="IconWrapper"] {
                    left: 30px;
                    color: #ffffff;
                }
            }
            div[aria-owns="region-dropdown"] {
                span[class^="IconWrapper"] {
                    left: 90px;
                    color: #ffffff;
                }
            }
        `,
    },
    dropdownSelect: {
        cssOverrides: {
            dropdownWrapper: css`
                min-width: 150px;
                width: -webkit-min-content;
                max-width: fit-content;
                > span {
                    text-transform: capitalize;
                    padding: 9px 0px 9px 11px !important;
                }
                ul#language-dropdown-listbox {
                    left: 3px;
                    overflow-y: hidden;
                }
                ul#region-dropdown-listbox {
                    left: -20px;
                }
                > ul {
                    box-sizing: border-box;
                    width: 140px;
                    border: 1px solid #48484e;
                    border-radius: 8px;
                    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
                    text-transform: capitalize;
                    overflow-y: hidden !important;
                    top: 3px;
                    transition: none !important ;
                    > div {
                        background-color: #33333a;
                        color: #ffffff;
                        font-size: 14px;
                        letter-spacing: 1.33px;
                        line-height: 16px;
                        box-sizing: border-box;
                        border-bottom: 1px solid #48484e;
                        &:hover {
                            background-color: #33333a;
                            color: #ffffff;
                        }
                    }
                }
                div[class^="divElement"] {
                    display: inline-block;
                    margin-left: 12px;
                }
                div[class^="selectedDivElement"] {
                    display: inline-block;
                    margin-left: 9px;
                }
            `,
            inputSelect: css`
                @-moz-document url-prefix() {
                    max-width: 100px;
                }
                font-weight: 300;
                background-color: #33333a;
                border: none;
                caret-color: transparent;
                cursor: pointer;
                &:focus {
                    border: none;
                }
            `,
        },
    },

    regionIcon: {
        size: 22,
        src: Region,
        css: css`
            margin-top: 10px;
            height: 20px;
            width: 20px;
        `,
    },

    iconElementEnabled: {
        css: css`
            margin-left: -3px;
            > svg {
                fill: #006bc0;
                stroke: #006bc0;
            }
        `,
    },

    iconElementDisabled: {
        size: 22,
        src: Region,
        css: css`
            margin-top: 10px;
            height: 20px;
            width: 20px;
            opacity: 0;
            z-index: -38;
            margin-left: -27px;
        `,
    },
};

const styles = dropdownStyles;
type State = { value: string | undefined };

const mapStateToProps = (state: ApplicationState) => ({
    languages: getLanguages(state),
    currentLanguage: state.context.session.language,
    currentWebsiteName: state.context.website.name,
    currentLanguageObject: state.context.session.language,
    currentLocation: getLocation(state),
    homePageUrl: getPageLinkByPageType(state, "HomePage")?.url,
});

const mapDispatchToProps = {
    setLanguage,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export const getRegions = (regions?: any) => {
    return regions;
};

// eslint-disable-next-line react/prefer-stateless-function
export class IntDropDown extends React.Component<Props, State> {
    options: any = [];
    regions: any = [];
    constructor(props: Props) {
        super(props);
        const { languages, currentLanguage, fields, currentWebsiteName, currentLanguageObject } = this.props;
        if (!fields?.languageMenu && fields?.itemName) {
            fields?.itemName.forEach((ele: any) => {
                this.regions.push({
                    region: ele.fields.menuName,
                    website: ele.fields.websiteId,
                    url: ele.fields?.destination?.value,
                });
                switch (currentWebsiteName.toLowerCase()) {
                    case "main":
                        ele.fields.websiteId === "main" ? (this.state = { value: ele.fields?.destination?.value }) : "";
                        break;
                    case "mx":
                        ele.fields.websiteId === "mx" ? (this.state = { value: ele.fields?.destination?.value }) : "";
                        break;
                    case "global":
                        ele.fields.websiteId === "global"
                            ? (this.state = { value: ele.fields?.destination?.value })
                            : "";
                        break;
                }
                this.options.push({
                    optionText: ele.fields.menuName,
                    optionValue: ele.fields?.destination?.value,
                    rowChildren: (
                        <div>
                            {this.state?.value === ele.fields?.destination?.value && (
                                <Icon {...styles.iconElementEnabled} src={Circle} size={6} />
                            )}
                            <div
                                className={
                                    this.state?.value === ele.fields?.destination?.value
                                        ? "selectedDivElement"
                                        : "divElement"
                                }
                            >
                                {ele.fields.menuName}
                            </div>
                        </div>
                    ),
                });
            });
            getRegions(fields);
        }

        if (fields?.languageMenu) {
            languages?.forEach((ele: any) => {
                this.options.push({
                    optionText: this.props.currentLanguage?.languageCode.toUpperCase(),
                    optionValue: ele.id,
                    rowChildren: (
                        <div>
                            {currentLanguage?.description === ele.description && (
                                <Icon {...styles.iconElementEnabled} src={Circle} size={6} />
                            )}
                            <div
                                className={
                                    currentLanguage?.description === ele.description
                                        ? "selectedDivElement"
                                        : "divElement"
                                }
                            >
                                {ele.description}
                            </div>
                        </div>
                    ),
                });
            });
            if (currentLanguage) {
                this.state = { value: currentLanguage?.id };
            }
        }
    }
    componentDidMount() {
        function getDataLayer() {
            return (window as any).dataLayer;
        }
        if (this.props.fields.languageMenu) {
            const dataLayer = getDataLayer();
            if (dataLayer) {
                dataLayer.push({
                    event: `Language${this.props.currentLanguageObject?.languageCode}`,
                    languageObject: this.props.currentLanguageObject,
                });
            }
        }
    }

    dropdownChange = (value?: string | undefined) => {
        if (value) {
            window.location.href = value;
        }
    };

    // five9 email widget page reload #loaded remove while click on change language dropdown.
    urlHashParameterRemoved = () => {
        const urlHashParameter = document.location.href;
        window.history.pushState({}, "", urlHashParameter.split("#")[0]);
    };

    urlRemoved = () => {
        const returnUrl = this.props.currentLocation.pathname;
        if (
            returnUrl.includes("/Cart") ||
            returnUrl.includes("/Checkout") ||
            returnUrl.includes("/OrderConfirmation") ||
            returnUrl.includes("/MyAccount") ||
            returnUrl.includes("/SignIn") ||
            returnUrl.includes("/ChangePassword")
        ) {
            this.props.history.push(`${this.props.homePageUrl}`);
        }
    };
    changeLanguage = (value?: string | undefined) => {
        this.urlHashParameterRemoved();
        this.urlRemoved();
        if (value) {
            this.props.setLanguage({ languageId: value });
        }
    };

    render() {
        return (
            <StyledWrapper
                {...styles.menuWrapper}
                id={this.props.fields.languageMenu ? "language-dropdown-wrapper" : "region-dropdown-wrapper"}
            >
                <Icon
                    {...(this.props.fields?.showIcon ? { ...styles.regionIcon } : { ...styles.iconElementDisabled })}
                />
                {this.options.length > 0 && (
                    <DynamicDropdown
                        {...styles.dropdownSelect}
                        options={this.options}
                        selected={this.props.fields.languageMenu ? this.props.currentLanguage?.id : this.state.value}
                        onSelectionChange={this.props.fields.languageMenu ? this.changeLanguage : this.dropdownChange}
                        uid={this.props.fields.languageMenu ? "language-dropdown" : "region-dropdown"}
                    />
                )}
            </StyledWrapper>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(IntDropDown)),

    definition: {
        group: "Basic",
        icon: "Menu",
        displayName: "IntDropdown Menu",
        fieldDefinitions: [
            {
                name: fields.itemName,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    return item?.fields?.menuName;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "menuName",
                        displayName: "Name",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "websiteId",
                        displayName: "Website ID",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Url",
                        },
                    },
                ],
            },
            {
                name: fields.showIcon,
                displayName: "Show Icon",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.languageMenu,
                displayName: "Is Language Menu",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 0,
            },
        ],
    },
};

export default widgetModule;
